import { StatsLvl } from './StatsLvl';

export const enum SeasonActual {
    Yes = 'yes',
    No = 'no'
}

export interface Season {
    id: number
    name: string
    year: string
    actual: SeasonActual
    stats_lvl: StatsLvl
}
